import { motion } from "framer-motion";
import { Users, Leaf as LeafIcon, Smile, Rocket } from "lucide-react";
import { Burst } from "@/components/home/Doodles";

const BENEFITS = [
  { icon: Users, t: "Voor mensen die zijn vastgelopen", d: "En weer vooruit willen in hun leven." },
  { icon: LeafIcon, t: "Persoonlijk en praktisch", d: "Ontwikkeling die aansluit bij jouw situatie." },
  { icon: Smile, t: "In een veilige groep", d: "Samen ontdekken, leren en stappen zetten." },
  { icon: Rocket, t: "Met blijvend perspectief", d: "Op weg naar een volgende stap die past." },
];

export function BenefitCard({ b, i }) {
  const Icon = b.icon;
  return (
    <motion.li
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: i * 0.08 }}
      className="group flex items-start gap-4"
      data-testid={`home-benefit-${i}`}
    >
      <span className="shrink-0 w-14 h-14 rounded-full bg-ll-mist flex items-center justify-center text-ll-leaf transition-transform duration-300 group-hover:-rotate-6 group-hover:scale-105">
        <Icon size={24} strokeWidth={1.8} />
      </span>
      <div>
        <p className="font-heading font-semibold text-lg leading-snug text-ll-forest">{b.t}</p>
        <p className="mt-1 text-sm text-ll-ink/75 leading-relaxed">{b.d}</p>
      </div>
    </motion.li>
  );
}

export default function BenefitCards() {
  return (
    <section className="bg-ll-cream" data-testid="home-benefits" aria-label="Waarom LevelLeven">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12 pb-16 sm:pb-20 relative">
        <h2 className="sr-only">Waarom LevelLeven?</h2>
        <Burst className="hidden lg:block absolute left-4 -top-2 w-8 h-8 text-ll-orange" />
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-10">
          {BENEFITS.map((b, i) => <BenefitCard key={b.t} b={b} i={i} />)}
        </ul>
      </div>
    </section>
  );
}
